/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The reason the bank account status changed to the current value.
 */
export const BankAccountStatusReason = {
  BankAccountCreated: "bank-account-created",
  VerificationInitiated: "verification-initiated",
  MicroDepositAttemptsExceeded: "micro-deposit-attempts-exceeded",
  MicroDepositExpired: "micro-deposit-expired",
  MaxVerificationFailures: "max-verification-failures",
  VerificationAttemptsExceeded: "verification-attempts-exceeded",
  VerificationExpired: "verification-expired",
  VerificationSuccessful: "verification-successful",
  AchDebitReturn: "ach-debit-return",
  AchCreditReturn: "ach-credit-return",
  RtpCreditFailure: "rtp-credit-failure",
  FednowCreditFailure: "fednow-credit-failure",
  MicroDepositReturn: "micro-deposit-return",
  AdminAction: "admin-action",
  Other: "other",
} as const;
/**
 * The reason the bank account status changed to the current value.
 */
export type BankAccountStatusReason = ClosedEnum<
  typeof BankAccountStatusReason
>;

/** @internal */
export const BankAccountStatusReason$inboundSchema: z.ZodNativeEnum<
  typeof BankAccountStatusReason
> = z.nativeEnum(BankAccountStatusReason);
/** @internal */
export const BankAccountStatusReason$outboundSchema: z.ZodNativeEnum<
  typeof BankAccountStatusReason
> = BankAccountStatusReason$inboundSchema;
